import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-lottery-applicant-view',
  templateUrl: './lottery-applicant-view.component.html',
  styleUrls: ['./lottery-applicant-view.component.css']
})
export class LotteryApplicantViewComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/allocation/lottery/lottery-applicant-view/lottery-applicant-view.component.ts